import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const navItems = [
  { to: "/", label: "Home", id: "nav-home" },
  { to: "/offer/pack-99", label: "$99.99 Pack", id: "nav-pack-99" },
  { to: "/offer/monthly-175", label: "Monthly Plan", id: "nav-monthly" },
  { to: "/about", label: "About", id: "nav-about" },
  { to: "/contact", label: "Contact", id: "nav-contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#080C14]/80 border-b border-[#3B9EFF]/15"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={n.id}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[#3B9EFF]" : "text-white/80 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex">
          <Link
            to="/offer/pack-99"
            className="btn-primary text-sm py-2.5 px-5"
            data-testid="header-cta-btn"
          >
            Get Content Now
          </Link>
        </div>
        <button
          className="md:hidden text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div
          className="md:hidden border-t border-[#3B9EFF]/15 bg-[#080C14]"
          data-testid="mobile-nav"
        >
          <div className="px-5 py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2 ${isActive ? "text-[#3B9EFF]" : "text-white/85"}`
                }
                data-testid={`mobile-${n.id}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/offer/pack-99"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2 justify-center"
              data-testid="mobile-cta-btn"
            >
              Get Content Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
